import {
  displayDate,
  displayTime,
  parseDate,
} from '@adsk/alloy-react-datetime';
import i18n from '../helpers/i18n';

const datesAreEqual = (dateA: Date, dateB: Date): boolean =>
  dateA.getDate() === dateB.getDate() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getFullYear() === dateB.getFullYear();

export const formatDate = (input: string): string => {
  if (!input) {
    return '';
  }
  const date = parseDate(input);
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (datesAreEqual(date, now)) {
    return i18n.t('TODAY_AT', {
      time: displayTime(date, { format: 'short' }),
    });
  } else if (datesAreEqual(date, yesterday)) {
    return i18n.t('YESTERDAY_AT', {
      time: displayTime(date, { format: 'short' }),
    });
  } else {
    // If a project was created before today, show the date in the format
    // Month DD, YYYY (localized)
    return displayDate(date, { format: 'short' });
  }
};

export const formatLongDate = (input: string): string => {
  if (!input) {
    return '';
  }
  const date = parseDate(input);

  return `${displayDate(date, {
    format: 'short',
  })} ${displayTime(date, {
    format: 'short',
  })}`;
};
